import React from 'react';
import UpsellWidgetCarousel from '@/frontastic/tastics/customercenter-ui/home/general-widget-carousel/upsell-widget-carousel';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';

const UpsellItems = ({ widgetData }: any) => {
  return (
    <Accordion type="single" collapsible defaultValue="upsell" className="w-full">
      <AccordionItem value="upsell">
        <AccordionTrigger className="text-lg font-bold">{widgetData?.widgetData?.text}</AccordionTrigger>
        <AccordionContent className="relative px-12">
          <UpsellWidgetCarousel data={widgetData} />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default UpsellItems;
